export const ADMIN = "admin";
export const STORE_GROUP = "storeGroup";
export const STORE = "store";
